import React,{ useState , useEffect } from 'react';
import logo from '../../images/logo_purple.png';
import { FormControl } from '@material-ui/core';
import { CustomLabel, CustomTextField,CustomButton } from "@tracknme/material-ui";
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../../store/actions';
import { phoneMask, cpfMask } from '../../utils/mask';
import alertMessage from '../../services/alertMessage';
import { UsersApi } from '../../services/Apis';
import Grid from '@material-ui/core/Grid';
import '../../mobile.css';


function Step4() {

  const dispatch = useDispatch();
  
  const { register, lead,navigation } = useSelector(({register}) => register);
  
  const [name,setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [cpfCnpj,setCpfCnpj] = useState(null);
  const [password,setPassword] = useState(null);
  const [confirmPassword,setConfirmPassword] = useState(null);
  const [errorPassword,setErrorPassword] = useState(false);
  const [validationRegistrationNumber,setValidationRegistrationNumber] = useState(null);
  const [validationPassword,setValidationPassword] = useState(false);
  const [errorEmail,setErrorEmail] = useState(null);
  const [validationEmail,setValidationEmail] = useState(null);
  const [loadData,setLoadData] = useState(false);
  const [errorPhoneNumber, setErrorPhoneNumber] = useState(false);
  const [loadLead, setLoadLead] = useState(false);
  const [errorCpf, setErroreCpf] = useState(false);
  const [nextStep,setNextStep] = useState(false);

  useEffect(() => {

    function checkValidEmail(){

      UsersApi.checkLogin(lead.email).then(response => {

        if(response.data === 0){
          setValidationEmail(true)
         setErrorEmail(false)

        }else{
          alertMessage.showErrorMessage("Esse login não está disponível!");
          setValidationEmail(false)
          setErrorEmail(true)
          dispatch(Actions.setNavigation(true));
    
        }
       
        return
      }).catch(error => {
        setValidationEmail(false)
          setErrorEmail(true)
        return
      })
    }

    if(lead && lead.name && !loadLead){
        setName(lead.name)
        setEmail(lead.email)
        setPhoneNumber(phoneMask(lead.mobile));
        setErrorPhoneNumber(false);
        setValidationEmail(true);
        setLoadLead(true);
        checkValidEmail();
    }
    
  }, [lead,dispatch,email,loadLead]);


  useEffect(() => {

    function checkValidEmail(){

      UsersApi.checkLogin(email).then(response => {

        if(response.data === 0){
          setValidationEmail(true)
         setErrorEmail(false)

        }else{
          alertMessage.showErrorMessage("Esse login não está disponível!");
          setValidationEmail(false)
          setErrorEmail(true)
          dispatch(Actions.setNavigation(true));
    
        }
       
        return
      }).catch(error => {
        setValidationEmail(false)
          setErrorEmail(true)
        return
      })
    }

    if(!loadData && register && register.administrator  ){
        
        let mobile = phoneMask(register.administrator.mobile);
        let registerNumber = cpfMask(register.administrator.cpfCnpj);
            setName(register.administrator.name);
            setPhoneNumber(mobile);
            setPassword(register.administrator.password);
            setEmail(register.administrator.login);
            setConfirmPassword(register.administrator.password)
            setCpfCnpj(registerNumber);
            setValidationRegistrationNumber(true);
            setErrorPhoneNumber(false);
            setValidationPassword(true);
            setValidationEmail(true);
            setLoadData(true);
            dispatch(Actions.setNavigation(false));

            console.log("Load EMAIL",register.administrator.login)

            checkValidEmail();
    }

  }, [loadData,register,dispatch,email ]);

  const handleChangeNameValue = ({target}) => {
    const {value} = target;
    setName(value);
  }

  const handleChangeEmailValue = ({target}) => {
    const {value} = target;
    setEmail(value);
  }

  const handleChangePasswordValue = ({target}) => {
    const {value} = target;
    setPassword(value);

    if(password && confirmPassword && (password === confirmPassword) && password.length > 7){
      setValidationPassword(true)
    }
  }

  const handleChangeConfirmPasswordValue = ({target}) => {
    const {value} = target;
    setConfirmPassword(value);

    if(password && confirmPassword && (password === confirmPassword) && password.length > 7){
      setValidationPassword(true)
    }
  }

  const handleChangePhoneNumberValue = ({target}) => {
    const {value} = target;
    let phone = phoneMask(value);
        setPhoneNumber(phone)
  }

  const handleChangeCpfCnpjValue = ({target}) => {
    const {value} = target;
    let registrationNumber = cpfMask(value);
    setCpfCnpj(registrationNumber);
  
    if(registrationNumber.length > 13){
      setValidationRegistrationNumber(true);
    }
   
  }

  const validationPhoneNumber = () => {
        
    if (phoneNumber && phoneNumber.length < 15) {
        alertMessage.showErrorMessage("Telefone inválido!");
        setErrorPhoneNumber(true)
        return
    }

    setErrorPhoneNumber(false)
}

 const checkPasswordLength = () => {
   
  if(password && password.length > 7){
    setValidationPassword(true)
    setErrorPassword(false)
  }else{
    alertMessage.showErrorMessage("A senha precisa conter no mínimo 8 caracteres!");
    setValidationPassword(false)
    setErrorPassword(true)
  }

}

  const checkPassword = () => {
   
    if(password && confirmPassword && (password === confirmPassword) && password.length > 7){
      setValidationPassword(true)
      setErrorPassword(false)
    }else{
      setValidationPassword(false)
      setErrorPassword(true)
      if(password && password.length < 8){
        alertMessage.showErrorMessage("A senha precisa conter no mínimo 8 caracteres!");
      }else{
        alertMessage.showErrorMessage("As senhas precisam ser iguais!");
      }

      
    }

  }

  const checkEmail = () => {
   
    if(validateEmail(email)){
     
      UsersApi.checkLogin(email).then(response => {

        if(response.data === 0){
          setValidationEmail(true)
         setErrorEmail(false)

        }else{
          alertMessage.showErrorMessage("Esse login não está disponível!");
          setValidationEmail(false)
          setErrorEmail(true)
          dispatch(Actions.setNavigation(true));
    
        }
       
        return
      }).catch(error => {
        setValidationEmail(false)
          setErrorEmail(true)
        return
      })
    }else{
      setValidationEmail(false)
      setErrorEmail(true)
      alertMessage.showErrorMessage("E-mail inválido!")
    }

  }

  function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  function validateCpf() {

    var strCpf = cpfCnpj ? cpfCnpj.replace(/\D/g, "") : null;

    if(!strCpf){
      return
    }

    var soma;
    var resto;
    soma = 0;

    let status = true;
    if (strCpf === "00000000000") {
      status = false;
    }
    var i = 1;
    for (i = 1; i <= 9; i++) {
        soma = soma + parseInt(strCpf.substring(i - 1, i)) * (11 - i);
    }
    
    resto = soma % 11;
    
    if (resto === 10 || resto === 11 || resto < 2) {
        resto = 0;
    } else {
        resto = 11 - resto;
    }
    
    if (resto !== parseInt(strCpf.substring(9, 10))) {
      status = false;
    }
    
    soma = 0;
     i = 1;
    for (i = 1; i <= 10; i++) {
        soma = soma + parseInt(strCpf.substring(i - 1, i)) * (12 - i);
    }
    resto = soma % 11;
    
    if (resto === 10 || resto === 11 || resto < 2) {
        resto = 0;
    } else {
        resto = 11 - resto;
    }
    
    if (resto !== parseInt(strCpf.substring(10, 11))) {
      status =false;
    }
    console.log('STATUS ->',status)
    if(status){
      setErroreCpf(false)
    }else{
      setErroreCpf(true)
      alertMessage.showErrorMessage("CPF inválido!")
    }
    }

  useEffect(() => {

    if(name && cpfCnpj && phoneNumber && validationRegistrationNumber && password && email && confirmPassword  && validationPassword && validationEmail && !errorPhoneNumber && !errorCpf){
    
      dispatch(Actions.setNavigation(false));
      
      let _register = register ? register : {};
     
      if(_register){
        _register['administrator'] = {
            "name": name,
            "login": email.toLowerCase(),
            "password": password,
            "mobile": phoneNumber.replace(/\D/g, ""),
            "cpfCnpj": cpfCnpj.replace(/\D/g, "")
        }

      }
         
      dispatch(Actions.setRegister(_register));
      setNextStep(true)
    }
    else if(!navigation){
      setNextStep(false)
    }
  }, [name, cpfCnpj, phoneNumber, errorCpf,validationRegistrationNumber, password, email, confirmPassword, navigation, validationPassword,validationEmail,dispatch,register,errorPhoneNumber ]);

  function changeBackStepValue() {
    dispatch(Actions.setStep(2));
  }
  
  function changeNextStepValue() {
    dispatch(Actions.setStep(4));
  }

  return (
    <div className="menuMobile">
        <div className="containerMobile">
        
            <div className="containerImage" >
                <img src={logo} className="logo" alt="Trackn'Me" />
            </div>
      
            <div className="titleStep4" >
                <CustomLabel label="Agora, por favor, insira alguns dados do administrador (pode ser você mesmo):" color="initial" component="h4" variant="h4" style={{fontSize:14, fontWeight:700, color:'#4D39E9'}} />  
            </div>

             <div className="textField">
                <FormControl>
                  <CustomTextField  label="E-mail do Login:" value={email} disabled={true} name="email_3" onFocus={() => setErrorEmail(true)} onChange={handleChangeEmailValue}  variant="filled" onBlur={() => checkEmail()}  onKeyPress={event => {if (event.key === 'Enter') {  checkEmail() }}} placeholder="Insira o e-mail que será usado no login" style={{width:'84vw'}} error={errorEmail}/> 
                  <CustomTextField  label="Nome do Administrador:" value={name}  name="name_3"  onChange={handleChangeNameValue}   variant="filled" placeholder="Insira o nome do administrador" style={{width:'84vw'}}/>  
                  <CustomTextField  label="CPF:" value={cpfCnpj}  name="cpf_3"  onChange={handleChangeCpfCnpjValue}  variant="filled" placeholder="000.000.000-00" style={{width:'84vw'}} onBlur={() => validateCpf(cpfCnpj)}   error={errorCpf}/>  
                  <CustomTextField  label="Celular:" onBlur={() => validationPhoneNumber()}  value={phoneNumber}  name="phone_3"  onChange={handleChangePhoneNumberValue} variant="filled" placeholder="Insira o celular, com o DDD" style={{width:'84vw'}} error={errorPhoneNumber}/>  
                  <CustomTextField  label="Senha:" value={password} onBlur={() => checkPasswordLength()} name="pass_1"  onChange={handleChangePasswordValue} variant="filled" type="password" placeholder="Insira uma senha de até 10 caracteres" style={{width:'84vw'}} error={errorPassword}/>  
                  <CustomTextField  label="Confirmar Senha:" value={confirmPassword} name="pass_2"  onChange={handleChangeConfirmPasswordValue} onBlur={() => checkPassword()}    onKeyPress={event => {if (event.key === 'Enter') {  checkPassword() }}} type="password" variant="filled" placeholder="Confirme a sua senha" style={{width:'84vw'}} error={errorPassword}/>  
                </FormControl>  
            </div>
         
            <div style={{height:100}}></div>
          
        </div>

        <div className="footer">
          <Grid container spacing={1}>
            <Grid item xs={4}  >
             
              <div className="center">
                <CustomButton   disabled={false} onClick={() => changeBackStepValue()} variant="contained" color="primary" label="Voltar" style={{height:'40px',marginTop:'20px', color:'#4D39E9', backgroundColor:'white', border: '3px solid #4D39E9'}}/> 
              </div>
            </Grid>
            <Grid item xs={4} >
              <div className="center">
                <CustomLabel  label=" Passo 3 – 6" color="initial" component="h4" variant="h4" style={{fontSize:14, fontWeight:400, color:'#929292', marginTop:'35px'}} />  
              </div>
            </Grid>
            <Grid item xs={4} >
            <div className="center"><CustomButton   disabled={false} onClick={() => nextStep ? changeNextStepValue() : {}} variant="contained" color="primary" label="Avançar" style={nextStep ? {height:'40px',marginTop:'20px'} : {height:'40px',marginTop:'20px',backgroundColor:'#BFBFBF'}}/> </div>
            </Grid>
          </Grid>
          
        </div>
        
       
        
     </div>
    
  );
}

export default Step4;

